import { Fragment } from 'react/jsx-runtime';
import type { CancellationReason } from '../../-api';
import { ReasonItem } from './reason-item';

interface ReasonSelectionProps {
	selectedReason: CancellationReason | null;
	cancellationReasons: CancellationReason[];
	onChange: (reason: CancellationReason) => void;
}

export const ReasonSelection = ({
	cancellationReasons,
	selectedReason,
	onChange,
}: ReasonSelectionProps) => {
	return (
		<Fragment>
			{cancellationReasons.map((reason) => (
				<ReasonItem
					key={reason.id}
					reason={reason}
					selected={selectedReason?.id === reason.id}
					onClick={() => onChange(reason)}
				/>
			))}
		</Fragment>
	);
};
